<template>
  <view-container title="Choose a battle">
    <template v-slot:heading>
      <span>{{ loggedIn ? `Your` : `Guest` }} battles</span>
    </template>

    <template v-slot:default>
      <new-battle-form />
    </template>

    <template v-slot:after>
      <router-link
        v-if="battle"
        :to="{ name: `home` }"
        class="py-4 inline-block"
      >
        Back&#160;to&#160;battle
      </router-link>
    </template>
  </view-container>
</template>

<script>
import ViewContainer from '@/components/ViewContainer'
import { mapGetters } from 'vuex'

export default {
  name: `BattlesView`,
  components: {
    ViewContainer,
    newBattleForm: () => import(`@/components/NewBattleForm`),
  },
  computed: {
    ...mapGetters(`accounts`, [`loggedIn`]),
    ...mapGetters(`battles`, [`battle`]),
  },
}
</script>
